export default __webpack_public_path__ + "static/media/mongodbfront.69ac0b57.svg";